var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTelegiveComeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 40,
    viewBox: "0 0 185 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 184,
    height: 40,
    rx: 20,
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2030_120417)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2030_120417)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2734 11.9792V17.2384H21.6641V28.0208H26.9232V17.2384H32.315V11.9792H26.9243L21.6641 17.2384V11.9792H16.2734Z",
    fill: "#080808"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.0287 28V23.9697H37.9788V21.9307H44.8655V17.9005H37.9788V16.0292H45.0276V12H33.2949V28H45.0287Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58 28V23.7776H50.7131V12H46.0293V28H56.58Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3138 28V23.9697H62.265V21.9307H69.1517V17.9005H62.265V16.0292H69.3138V12H57.5801V28H69.3138Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3125 20C70.3125 24.9393 74.1386 28 78.8224 28C81.8605 28 84.1794 26.7708 85.8949 24.8696V18.6549H78.3587V22.5046H81.3495V23.1766C80.7462 23.6167 79.8187 23.8722 78.8224 23.8722C76.5734 23.8722 75.0661 22.1567 75.0661 20C75.0661 17.8433 76.5734 16.1278 78.8224 16.1278C80.144 16.1278 81.1649 16.8696 81.6748 17.8207L85.6168 15.8035C84.5498 13.8089 82.4166 12 78.8224 12C74.1386 12 70.3125 15.0381 70.3125 20Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5803 28V12H86.8965V28H91.5803Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.173 28L109.878 12H104.567L101.228 22.7703L97.8898 12H92.5801L98.2849 28H104.173Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.877 26C110.877 27.0844 111.793 28 112.877 28C113.961 28 114.877 27.0844 114.877 26C114.877 24.9156 113.961 24 112.877 24C111.793 24 110.877 24.9156 110.877 26Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.271 28C128.445 28 130.508 25.5416 131.413 23.4783L127.379 21.6232C126.985 22.8288 125.779 23.8722 124.272 23.8722C122.139 23.8722 120.632 22.1567 120.632 20C120.632 17.8433 122.139 16.1278 124.272 16.1278C125.779 16.1278 126.985 17.1712 127.379 18.3768L131.413 16.4981C130.486 14.365 128.445 12 124.271 12C119.541 12 115.877 15.2228 115.877 20C115.877 24.7536 119.541 28 124.271 28Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.414 20C132.414 24.7536 136.101 28 140.878 28C145.655 28 149.342 24.7536 149.342 20C149.342 15.2464 145.655 12 140.878 12C136.102 12 132.414 15.2464 132.414 20ZM144.588 20C144.588 22.1567 143.127 23.8722 140.878 23.8722C138.629 23.8722 137.168 22.1567 137.168 20C137.168 17.8433 138.629 16.1278 140.878 16.1278C143.128 16.1278 144.588 17.8433 144.588 20Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.706 28V12H162.237L159.524 20.156L156.811 12H150.342V28H155.026V17.9005L158.48 28H160.567L164.022 17.9005V28H168.706Z",
    fill: "#080808"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2030_120417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152.41,
    height: 16,
    fill: "white",
    transform: "translate(16.2949 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2030_120417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16.2949 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTelegiveComeLight);
export default __webpack_public_path__ + "static/media/logo-telegive-come-light.2586a5c276fa7cd8d36ee42009b65176.svg";
export { ForwardRef as ReactComponent };